/* eslint-disable sort-keys */
/**
 * Rótulos dos tipos de relatório. O backend guarda o `model` exatamente como o
 * front enviou no POST /v1/reports, então as duas grafias (CamelCase e
 * snake_case) precisam estar mapeadas.
 */
export const reportTypeMapper: Record<string, string> = {
  Customer: 'Clientes',
  Billing: 'Cobranças',
  BillingDetailed: 'Cobranças detalhadas',
  Receivable: 'Recebíveis',
  Transfer: 'Transferências',
  TransferDetailed: 'Transferências detalhadas',
  billing_transfer: 'Detalhes da transferência',
  Contract: 'Contratos',
  Recurrence: 'Recorrências',
  recurrence: 'Recorrências',
  Nfse: 'Notas Fiscais',
  ProductLink: 'Link de Contratação',
  RegisterLink: 'Link de Cadastro',
  AccountsPayable: 'Contas a pagar',
  AccountsReceivable: 'Contas a receber',
  accounts_receivable: 'Contas a receber',
  Dre: 'DRE',
  dre: 'DRE',
  cash_flow: 'Fluxo de caixa',
  CashFlow: 'Fluxo de caixa',
  Installment: 'Parcelamentos',
  StatementDatePaid: 'Extrato Financeiro (Data de Pagamento)',
  StatementExpectedOn: 'Extrato Financeiro (Data de Liberação)',
  customer_sheet: 'Fichas Cadastrais',
  CustomerSheet: 'Fichas Cadastrais',
  customer_billings: 'Cobranças do cliente',
  CustomerBillings: 'Cobranças do cliente',
  recurrence_carne: 'Carnê',
  RecurrenceCarne: 'Carnê',
  MessengerTracking: 'Envios de mensagem',
  messenger_tracking: 'Envios de mensagem',
  Product: 'Produtos',
  ProductCharge: 'Cobranças de produto',
  product_charge: 'Cobranças de produto',
  RevenueByPlan: 'Receita por plano',
  MrrDetailed: 'MRR detalhado',
  mrr_detailed: 'MRR detalhado'
}

export const getReportTypeLabel = (model: string): string =>
  reportTypeMapper[model] || model
